import { Button, Card, Icon, Stack, Text, tokens } from '@/design';

interface MissingGeometryDiagnosticsProps {
  missingCount: number;
  onOpenRemap(): void;
}

export function MissingGeometryDiagnostics({
  missingCount,
  onOpenRemap,
}: MissingGeometryDiagnosticsProps) {
  if (missingCount <= 0) return null;

  return (
    <div
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      style={{
        position: 'absolute',
        left: tokens.space[2],
        top: tokens.space[2],
        zIndex: tokens.zIndex.panel,
        width: tokens.layout.rightPanel,
        maxWidth: '100%',
      }}
    >
      <Card
        level={2}
        header="Missing geometry diagnostics"
        actions={(
          <Button variant="secondary" onClick={onOpenRemap} aria-label="Open remap workflow">
            <Icon name="open_in_new" size={20} decorative />
            <span>Open remap workflow</span>
          </Button>
        )}
      >
        <Stack direction="row" align="center" gap={1}>
          <Icon name="deployed_code_alert" size={20} decorative />
          <Text as="p" variant="body" style={{ margin: 0 }}>
            {missingCount} object{missingCount === 1 ? '' : 's'} have missing geometry mappings.
          </Text>
        </Stack>
      </Card>
    </div>
  );
}
